import type { SVGProps } from "react"

const PermissionsGPS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 1587" transform="translate(385.428)" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 4060" transform="translate(-385.428)" clipPath="url(#prefix__a)">
      <path
        data-name="Path 41488"
        d="M570.067 208.773a8.338 8.338 0 012.63 1.727 1.908 1.908 0 010 3 8.38 8.38 0 01-2.631 1.727 27.09 27.09 0 01-19.279 0 8.367 8.367 0 01-2.63-1.727 1.905 1.905 0 010-3 8.331 8.331 0 012.63-1.727 19.542 19.542 0 014.511-1.332l-1.141-1.3a20.2 20.2 0 00-3.984 1.26 9.691 9.691 0 00-3.107 2.066 3.377 3.377 0 000 5.06 9.694 9.694 0 003.107 2.067 28.558 28.558 0 0020.506 0 9.705 9.705 0 003.108-2.067 3.38 3.38 0 000-5.06 9.719 9.719 0 00-3.109-2.066 20.536 20.536 0 00-4.322-1.332l-1.155 1.313a19.987 19.987 0 014.864 1.388"
        fill="#98a300"
      />
      <path
        data-name="Path 41489"
        d="M560.224 134.5a31.237 31.237 0 00-22.469 53l16.4 18.644 1.141 1.3 2.675 3.041a3 3 0 004.505 0l2.724-3.1 1.155-1.313 16.378-18.616a31.237 31.237 0 00-22.509-52.956m.2 46a14.5 14.5 0 1114.5-14.5 14.517 14.517 0 01-14.5 14.5"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 41490"
        d="M560.427 151.5a14.5 14.5 0 1014.5 14.5 14.516 14.516 0 00-14.5-14.5m0 27.5a13 13 0 1113-13 13.015 13.015 0 01-13 13"
        fill="#98a300"
      />
      <path
        data-name="Path 41491"
        d="M560.427 109.5a65.5 65.5 0 1065.5 65.5 65.574 65.574 0 00-65.5-65.5m0 129.5a64 64 0 1164-64 64.073 64.073 0 01-64 64"
        fill="#98a300"
      />
    </g>
  </svg>
)
export { PermissionsGPS }
